export default __webpack_public_path__ + "static/media/Trash.d2cf8ab5.svg";